import * as React from 'react';
import { MarginContainer } from '../../lib/shared';
import {
  AboutHeader,
  AboutHeaderContainer,
  YellowCirclesImg,
  SpeakerImg,
  AboutHeaderMobile,
  AboutHeaderDesktop,
  AboutHorizontalRedLines,
  AboutHorizontalRedLinesXl,
} from './AboutHeaderSection.style';
import { icons } from '../../style/icons';

const AboutHeaderSection = ({ title1, title2, title3 }) => {
  return (
    <>
      <SpeakerImg
        src={icons.MIC2_PERIWINKLEBLUE.image}
        alt={icons.MIC2_PERIWINKLEBLUE.altText}
      />
      <YellowCirclesImg
        src={icons.YELLOW_CIRLES.image}
        alt={icons.YELLOW_CIRLES.altText}
      />
      <AboutHorizontalRedLines
        src={icons.HORIZONTAL_RED_LINES.image}
        altText={icons.HORIZONTAL_RED_LINES.altText}
      />
      <AboutHorizontalRedLinesXl
        src={icons.HORIZONTAL_RED_LINES_XL.image}
        altText={icons.HORIZONTAL_RED_LINES_XL.altText}
      />
      <MarginContainer>
        <AboutHeaderContainer>
          <AboutHeader>{title1.text}</AboutHeader>
          <AboutHeaderDesktop>{title2.text}</AboutHeaderDesktop>
          <AboutHeaderMobile>{title2.text.slice(0, 5) + '-'}</AboutHeaderMobile>
          <AboutHeaderMobile>{title2.text.slice(5)}</AboutHeaderMobile>
          <AboutHeader>{title3.text}</AboutHeader>
        </AboutHeaderContainer>
      </MarginContainer>
    </>
  );
};

export default AboutHeaderSection;
